import { TeamPathsQuery, TeamQuery, TeamQueryVariables } from '@/graphql';
import TeamQueryDocument from '@/graphql/queries/Team.gql';
import TeamPathsQueryDocument from '@/graphql/queries/TeamPaths.gql';
import CraftClient from '@/lib/graphql';
import { getStaticPagePaths, getStaticPageProps } from '@/lib/next';
import MasterTemplate from '@/templates/MasterTemplate';
import TeamsLegacyLayout from '@/layouts/pages/teams/TeamsLegacy';
import { ModularPageProps, parseModuleBuilderProps } from '@/modules/ModuleBuilder';
import ModularPageLayout from '@/layouts/ModularPageLayout';

const Team: PageTemplate<TeamQuery | ModularPageProps> = (props) => {
  if ('modularPageProps' in props) {
    return <ModularPageLayout props={props.modularPageProps} />;
  }

  if ('entry' in props && props.entry?.__typename) {
    return <TeamsLegacyLayout {...props} />;
  }

  return null;
};

Team.template = MasterTemplate;

export default Team;

export const getStaticPaths = getStaticPagePaths('teams', async (context) => {
  const client = new CraftClient();

  const data = await client.request<TeamPathsQuery>(TeamPathsQueryDocument);

  const paths =
    data.entries?.map((path) => ({
      params: {
        slug: path?.slug!,
      },
    })) || [];

  return {
    paths,
    fallback: 'blocking',
  };
});

export const getStaticProps = getStaticPageProps<{}, { slug: string }>(
  (params) => `teams/${params?.slug}`,
  async ({ client, context: { params } }) => {
    const props = await client.request<TeamQuery, TeamQueryVariables>(TeamQueryDocument, {
      slug: params?.slug,
    });

    if (!props.entry) {
      return { notFound: true };
    }

    if (props.entry.__typename === 'teams_modular_Entry') {
      return {
        props: parseModuleBuilderProps({
          ...props,
          entry: props.entry, // HACK Stupid TS
        }),
      };
    }

    return {
      props,
    };
  },
);
